/** The central operator's planning archive in Settings → Tenants, before a purge (Phase 2 P2-5). */
export default {
  archive: {
    title: 'Planning case archive',
    intro:
      'Purging deletes every planning case, its history and its files. Create an archive package of each case, download the packages with the public keys, and hand them to the customer first.',
    none: 'This tenant has no planning cases.',
    loading: 'Reading the planning cases…',
    loadFailed: 'The planning cases could not be read.',
    retryLoad: 'Try again',
    counts: '{{archived}} of {{cases}} cases have a current archive package.',
    liveJobs:
      'Packages being built: {{exports}}. Drawing checks running: {{intakes}}. Package imports in progress: {{imports}}. Jobs waiting for the worker: {{queued}}.',
    create: 'Create archive packages',
    retryFailed: 'Retry the failed ones',
    stop: 'Stop',
    working: 'Creating archive packages…',
    gapsTitle: 'Cases without a current archive package',
    gapsMore: '{{count}} more are not listed.',
    reasons: {
      no_archive: 'No archive package yet',
      stale: 'The package is older than the latest change',
      running: 'Being built',
      failed: 'The package could not be built',
      revoked: 'Sealed with a revoked key: it will be built again',
      chain_broken: 'The history failed verification: no package can be built',
    },
    packagesTitle: 'Archive packages',
    packageLine: 'Up to event {{seq}}',
    download: 'Download',
    downloadLabel: 'Download the archive package of {{caseRef}}',
    downloadFailed: 'The package could not be downloaded.',
    more: 'Show more packages',
    jwks: 'Download the public keys (JWKS)',
    jwksHint: 'The purge destroys the signing keys. Without this file nobody can check the packages afterwards.',
    delivered: 'I have handed the archive packages and the public keys to the customer.',
    waiver: 'Purge without a package for all {{total}} cases that lack a current one',
    waiverHint:
      'Use this only when a case cannot be archived, or when the customer has instructed it in writing. The audit log records it.',
    waiverReason: 'Reason',
    waiverReasons: {
      unarchivable: 'The cases cannot be archived',
      controller_instruction: 'The customer instructed it',
    },
    blocked: {
      jobs_running: 'Wait until the packages being built, the drawing checks and the package imports have finished.',
      unarchived: 'Every case needs a current archive package, or the waiver below.',
      not_confirmed: 'Confirm that the archive packages were handed over.',
    },
    refusal: {
      planning_jobs_running:
        'The purge was refused: {{exports}} packages, {{intakes}} drawing checks and {{imports}} package imports are still running, and {{queued}} jobs are waiting for the worker.',
      planning_cases_unarchived: 'The purge was refused: {{total}} cases have no current archive package.',
      planning_archives_not_confirmed:
        'The purge was refused: confirm that the {{archived}} archive packages were handed over.',
      planning_register_unreachable:
        "The purge was refused: the planning register server {{host}} ({{database}}) does not answer, so this tenant's rows on it cannot be deleted. Fix the connection, or purge without deleting them.",
    },
    registerSkip:
      "Purge without deleting this tenant's rows on that register server. They stay on it; the audit log records it.",
    incomplete: 'The tenant data is gone, but some planning files remain. Run the purge again to finish.',
  },
}
